module.exports = __webpack_public_path__ + "img/gallery-10.ccfc03bc.jpg";